var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummarymobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.595,
    height: 27.592,
    viewBox: "0 0 27.595 27.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Broken_Activity",
    "data-name": "Iconly/Broken/Activity",
    transform: "translate(-2.759 -2.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(2.759 2.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Activity-2",
    "data-name": "Activity",
    d: "M14.217,27.592a1.022,1.022,0,0,1-1.024-1.009,1.035,1.035,0,0,1,1.024-1.022H18.29c4.035,0,6.267-2.214,6.3-6.253v-8.93a1.006,1.006,0,1,1,2.013,0v8.93c0,5.109-3.195,8.284-8.315,8.284ZM0,19.308V9.368c0-5.122,3.182-8.3,8.3-8.3h8.975A1.025,1.025,0,0,1,18.29,2.092,1.013,1.013,0,0,1,17.265,3.1H8.3c-4.035,0-6.267,2.226-6.267,6.265v9.94c0,4.039,2.231,6.253,6.267,6.253a1.035,1.035,0,0,1,1.024,1.022A1.022,1.022,0,0,1,8.3,27.592C3.182,27.592,0,24.417,0,19.308Zm6.413-.839a1.022,1.022,0,0,1-.183-1.424l3.987-5.183a1.027,1.027,0,0,1,1.439-.183L15.4,14.612l3.293-4.2a1.011,1.011,0,0,1,1.584,1.217l-3.9,5.025a1.088,1.088,0,0,1-.683.389,1.024,1.024,0,0,1-.744-.219L11.2,13.894,7.84,18.261a1.017,1.017,0,0,1-.816.412A1.016,1.016,0,0,1,6.413,18.468ZM20.423,3.59a3.586,3.586,0,1,1,3.585,3.564A3.567,3.567,0,0,1,20.423,3.59Zm2.036,0a1.548,1.548,0,1,0,1.548-1.546A1.548,1.548,0,0,0,22.459,3.59Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarymobile);
export default __webpack_public_path__ + "static/media/summarymobile.b46ee34959a4990628311654c87146da.svg";
export { ForwardRef as ReactComponent };